<!-- customizer -->
<!-- <app-customizer></app-customizer> -->
<!-- /customizer -->
<div class="page">

    <!-- Sidemenu -->
    <app-sidemenu (mouseover)="hoverEffect($event)" (mouseout)="hoverEffect($event)"></app-sidemenu>
    <!-- /Sidemenu -->

    <!-- Header -->
    <app-header></app-header>
    <!-- /Header -->
    <app-toast-container aria-live="polite" aria-atomic="true"></app-toast-container>
    
    <!-- <app-customizer></app-customizer> -->

    <!-- Main Content -->
    <div class="main-content side-content pt-0">
        <div class="d-flex justify-content-end toastContainerPosition">
        </div>
        <div class="container-fluid">
            <div class="inner-body" (click)="clickonBody()">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    <!-- /Main Content -->

    <!-- Footer -->
    <app-footer></app-footer>
    <!-- /Footer -->

    <!-- Notification-sidebar -->
    <app-notification-sidebar></app-notification-sidebar>
    <!-- /Notification-sidebar -->
</div>